import React, { useState } from 'react';

import './styles.css';

import { useHistory } from 'react-router';

import classServices from '../../../services/academy/classServices';
import convertClassType from '../../../services/dataConverters/convertClassType';

import MainView from '../../../components/MainView';
import NavHistory from '../../../components/NavHistory';
import Input from '../../../components/Input';

function NewClass() {
    const history = useHistory();
    const [name, setName] = useState('');
    const [vacancies, setVacancies] = useState(10);
    const [type, setType] = useState('');
    const [ageGroup, setAgeGroup] = useState('');

    const ageGroupOptions = [
        "SUB 5",
        "SUB 6",
        "SUB 7",
        "SUB 8",
        "SUB 9",
        "SUB 10",
        "SUB 11",
        "SUB 12",
        "SUB 13",
        "SUB 14",
        "SUB 15",
        "SUB 16",
        "SUB 17",
        "SUB 18"
    ]

    async function createClass() {
        console.log(name);
        console.log(vacancies);
        console.log(type);
        console.log(ageGroup.split(' - ')[0].substring(4));
        if (name && vacancies && type && ageGroup) {
            const response = await classServices.postClass(name, vacancies, convertClassType(type), ageGroup.substring(4));
            if (response.status === 201) {
                history.goBack();
            } else
                alert("Erro ao criar turma, tente novamente!");
        } else
            alert("Preencha os dados obrigatórios");
    }

    return (
        <MainView currentPage='classes'>
            <NavHistory navPages={['Turmas', 'Cadastrar']} />
            <form className='new-class-page-form' action="">
                <h4>Cadastro de turma</h4>
                <Input
                    label='Nome*'
                    placeholder="Nome"
                    id='new-class-form-name'
                    onChange={(event) => setName(event.target.value)}
                    value={name}
                />
                <Input
                    type='number'
                    label='Vagas*'
                    id='new-class-form-vacancies'
                    onChange={(event) => setVacancies(event.target.value)}
                    value={vacancies}
                />
                <Input
                    type='select'
                    noFilterOptions
                    options={['Feminina', 'Masculina', 'Mista']}
                    label='Tipo*'
                    id='new-class-form-type'
                    onChange={(event) => setType(event.target.value)}
                    value={type}
                />
                <Input
                    type='select'
                    noFilterOptions
                    options={ageGroupOptions}
                    label='Faixa etária*'
                    id='new-class-form-age-group'
                    onChange={(event) => setAgeGroup(event.target.value)}
                    value={ageGroup}
                />
                <button type='button' onClick={createClass}>Criar turma</button>
            </form>
        </MainView>
    )
}

export default NewClass;